module.exports = __webpack_public_path__ + "img/logo_2.3b54535f.png";